'use client';

import type { FC } from 'react';

import { useMediaType } from '@packages/shared/src/hooks/useMediaType/useMediaType';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import type { Device } from '@packages/shared/src/utils/types';

import { useNavigationData } from '../useNavigationData';
import { ResponsiveNavigation } from './ResponsiveNavigation.client';
import type { RawNavigationItem } from './navigationTypes';

export type ResponsiveNavigationLoaderProps = {
  device: Device;
};

/**
 * Client-side data fetching wrapper around {@link ResponsiveNavigation}
 */
export const ResponsiveNavigationLoaderClient: FC<ResponsiveNavigationLoaderProps> = ({
  device,
}) => {
  const {
    header: { desktopNavigationMode },
  } = useConfig();
  const isDesktop = useMediaType();

  const { data, loadFullData } = useNavigationData();

  return (
    <ResponsiveNavigation
      mode={device === 'desktop' && isDesktop ? desktopNavigationMode : 'click'}
      items={data as RawNavigationItem[]}
      onFirstInteraction={loadFullData}
    />
  );
};
